/**
 * Format a date as DD-MMM-YYYY HH:MM:SS or DD-MMM-YYYY
 * @param {string|Date} dateStr
 * @param {boolean} includeTime - Whether to include HH.MM.SS (default: true)
 * @returns {string} Formatted date or "—"
 */
export const formatOADateTime = (dateStr, includeTime = true) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "—";
    const pad = (n) => String(n).padStart(2, '0');
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    const datePart = `${pad(d.getDate())}-${months[d.getMonth()]}-${d.getFullYear()}`;
    if (!includeTime) return datePart;

    // COL-133: time uses colon separators (HH:MM:SS), e.g. 08-Jul-2026 12:09:27
    return `${datePart} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

/**
 * Format a date as DD-MMM-YYYY (e.g., 19-Jun-2026)
 * @param {string|Date} dateInput
 * @returns {string} Formatted date or "—"
 */
export const formatDateDDMMMYYYY = (dateInput) => {
    if (!dateInput) return "—";
    // If the input is just date string "YYYY-MM-DD", parsing it with new Date() in local time
    // can shift timezone. So we extract the components or append T00:00:00 to parse in local context.
    let d;
    if (typeof dateInput === "string" && dateInput.includes("-") && !dateInput.includes("T")) {
        d = new Date(`${dateInput}T00:00:00`);
    } else {
        d = new Date(dateInput);
    }
    if (isNaN(d.getTime())) return "—";
    const pad = (n) => String(n).padStart(2, '0');
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${pad(d.getDate())}-${months[d.getMonth()]}-${d.getFullYear()}`;
};
